<template lang="pug">
footer.v-page-footer.page-footer
	.page-footer__overlay(ref="overlay" )
	video.page-footer__video( ref="video" muted loop playsinline)
		source.page-footer__video-source(:src="video" type="video/mp4")
	.page-footer__container.container
		.page-footer__wrap
			.page-footer__left
				template(v-if="$slots['contact-list']")
					.page-footer__contact-list-wrap.flc
						slot(name="contact-list")
				template(v-if="$slots['socials']")
					.page-footer__socials-wrap.flc
						slot(name="socials")
				template(v-if="$slots['legal-info']")
					.page-footer__legal-info-wrap.flc
						slot(name="legal-info")
			.page-footer__right(v-if="$slots['form']")
				.page-footer__form-wrap(data-hash="#bottom-form")
					slot(name="form")
</template>

<script>
import controller from "../scripts/controller/controller.js";
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		isMobMixin
	],

	props: {
		video: {
			type: String,
			default: null
		},
		mobImage: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			playPromise: null
		};
	},

	mounted() {
		this.handleScroll();
		console.log(this.$slots)
		window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		handleScroll() {
			let $video = this.$refs['video'];
			let $overlay = this.$refs['overlay'];
			if (!$video) return; // Защита от ошибок

			const isVisible = window.scrollY + window.innerHeight > this.$el.offsetTop;

			if (isVisible) {

				$video.style.zIndex = '-2';
				$overlay.style.zIndex = '-1'

				if ($video.paused) {
					this.playPromise = $video.play();
					if (this.playPromise !== undefined) {
						this.playPromise.catch(error => {
							console.log("Автоплей заблокирован браузером:", error);
						});
					}
				}
			} else {
				if (!$video.paused) {
					$video.pause();
				}

				$video.style.zIndex = $overlay.style.zIndex = '-4';
			}
		}
	}
};
</script>
